/**
 * @file schemas/case-document-reviews.ts
 * @description 案件申請文件審核 Zod schema（前後端共用，M1）。
 *
 * - submitCaseDocumentReviewSchema  manager 提交審核 body
 * - decideCaseDocumentReviewSchema  組長決議 body（discriminated union：approved 選填 comment、rejected 必填 comment）
 * - CaseDocumentReviewDto           給前端用的審核流水 DTO 型別
 */
import { z } from 'zod';
/** 提交審核請求 body */
export const submitCaseDocumentReviewSchema = z.object({
    /** 提交備注，留給組長看的話 */
    submitterNote: z.string().max(2000).optional(),
    /**
     * 未上傳檔案原因說明（序57 新版）：應附文件清單有分類未上傳時必填
     * （必填校驗由前端把關——後端不知道業務上哪些分類此案必備）。
     */
    missingReason: z.string().max(2000).optional(),
});
/** 決議請求 body（序57：文件點檢通過帶點檢人簽名、不通過帶原因分類） */
export const decideCaseDocumentReviewSchema = z.discriminatedUnion('decision', [
    z.object({
        decision: z.literal('approved'),
        comment: z.string().max(2000).optional(),
        /**
         * 點檢人簽名檔 file id。
         * UI 必填（點檢通過須簽名），schema 設 optional 以免破壞既有測試/兼容舊呼叫。
         */
        signatureFileId: z.number().int().positive().optional(),
    }),
    z.object({
        decision: z.literal('rejected'),
        /** rejected 必填，至少 1 字 */
        comment: z.string().min(1, '不通過必須填寫意見').max(2000),
        /**
         * 不通過原因分類（序57）：
         *   - 'incomplete'  文件不齊全 → 需補充
         *   - 'unclear'     文件不清晰 → 需重傳
         * UI 必選，schema 設 optional 以免破壞既有測試/兼容舊呼叫。
         */
        rejectionReasonType: z.enum(['incomplete', 'unclear']).optional(),
    }),
]);
